enum CampaignFeaturesForTracking {
	GENERAL = 'feature_general',
	ACCOUNT_MANAGERS = 'feature_account_managers',
	CLIENT_SERVICES_PEOPLE = 'feature_client_services_people',
	LISTING_ENTITIES = 'feature_listing_entities',
	CUSTOM_PRODUCTS = 'feature_custom_products',
	RIGHTS = 'feature_rights',
	AUDITOR = 'feature_auditor',
	PRICING_PRODUCTS = 'feature_pricing_products',
	CAMPAIGN_READINESS_INFO = 'feature_campaign_readiness_info',
	CREATION = 'feature_creation'
}

enum CampaignSaveLoadLabels {
	SAVE = 'save',
	LOAD = 'load'
}

enum CampaignSaveLoadOutcomes {
	SUCCESS = 1,
	FAILURE = 0
}

enum CampaignLoadingSpeedLabels {
	INITIAL_LOAD = 'initial_load',
	TAB_SWITCH = 'tab_switch'
}

export {
	CampaignFeaturesForTracking,
	CampaignSaveLoadLabels,
	CampaignSaveLoadOutcomes,
	CampaignLoadingSpeedLabels
}
